module.exports = __webpack_public_path__ + "static/media/code@2x.89175b7e.png";